import { PageResponse } from '@omnia/ui/src/lib'
import type { HeroCarouselPropsApi } from '@/common/components/heroCarousel/heroCarousel.models'
import type { CineColombiaGridRow } from '@/features/grid/grid.types'

export class HomePageResponse extends PageResponse {
    public grid: CineColombiaGridRow[]
    public heroCarousel: HeroCarouselPropsApi['HeroCarousel']
}
